/**
 * Workspace Page
 * 
 * Main task-based dashboard showing actionable items instead of features.
 * Implements "Task-First, Not Feature-First" UX paradigm.
 * Uses SimplifiedSidebar for reduced navigation complexity.
 * 
 * @see UX_ACTION_PLAN_ENHANCED_2025-10-13.md
 */

import { AppLayout } from "@/components/layout/app-layout";
import { TaskDashboard } from "@/components/dashboard/TaskDashboard";

const Workspace = () => {
  return (
    <AppLayout>
      <main className="flex-1 overflow-y-auto">
        <TaskDashboard />
      </main>
    </AppLayout>
  );
};

export default Workspace;
